import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import $ from 'jquery';

import header from './data/header.json';
import homeServices from './data/homeServices.json';
import homeDeliveries from './data/homeDeliveries.json';
import homeContact from './data/homeContact.json';
import contactInfo from './data/contact.json';

import Header from "./components/Header"; 
import Navbar from './components/Navbar';
import Home from "./Home";
import Booklets from "./Booklets";
import BusinessCards from "./BusinessCards";
import Printing from "./Printing";
import Contact from "./Contact";
import Submission from './Submission';
import Footer from "./components/Footer";

class App extends Component {

  state = {
    header: header,
    home: [homeServices, homeDeliveries, homeContact],
    contact: contactInfo,
    formBookletData: {},
    formPrintingData: {}
  };

  // componentDidMount() {
  //   $('[data-toggle="tooltip"]').tooltip();
  // }
  
  handleChange = (e) => {
    const itemName = e.target.name;
    const itemValue = e.target.value;
 
    $(e.target).prop("checked", true)

    const fields = this.state.formBookletData;
    fields[itemName] = itemValue;
    
    this.setState({
      formBookletData: fields,
    });
  }

  handleChangeOther = (e) => {
    const itemName = e.target.name;
    const itemValue = e.target.value;
    const target = $(e.target).siblings('input');
    
    target.prop("checked", true).attr("value", itemValue);

    const fields = this.state.formBookletData;
    fields[itemName] = itemValue;
    
    // this.setState({
    //   formBookletData: fields,
    // });
  }

  handleSubmit = (e) => {
    // e.preventDefault();
    
    const source = this.state.formBookletData;
    const data = {};
    data.fields = [];
    const fields = data.fields;
    for (const key in source) {
      const field = {};
      field.name = key;
      field.value = source[key];  
      fields.push(field);
    }
    // console.log(data);
  
    // var xhr = new XMLHttpRequest();
    // var url = 'https://api.hsforms.com/submissions/v3/integration/submit/7785021/971a719f-28b8-420d-a84d-46ac6cff4fb7'

    // var final_data = JSON.stringify(data)
  
    // xhr.open('POST', url);
  
    // xhr.setRequestHeader('Content-Type', 'application/json');
  
    // xhr.onreadystatechange = function() {
    //     if(xhr.readyState === 4 && xhr.status === 200) { 
    //         alert(xhr.responseText); // Returns a 200 response if the submission is successful.
    //     } else if (xhr.readyState === 4 && xhr.status === 400){ 
    //         alert(xhr.responseText); // Returns a 400 error the submission is rejected.          
    //     } else if (xhr.readyState === 4 && xhr.status === 403){ 
    //         alert(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.           
    //     } else if (xhr.readyState === 4 && xhr.status === 404){ 
    //         alert(xhr.responseText); //Returns a 404 error if the formGuid isn't found     
    //     }
    //    }
    
    // xhr.send(final_data)
  }
  
  render() {

    const { hero } = this.state.header;
    const { home } = this.state;

    return (  
      <Router>
        <Switch>
          <Route 
            exact path="/" 
            render={() => (
              <>
                <Header 
                  heading={hero[0].heading} 
                  description={hero[0].description}
                  list={hero[0].list} 
                  altText={hero[0].altText}
                  image={hero[0].image}
                  bgImage={hero[0].bgImage}
                  template={hero[0].template}
                />
                <Home home={home} />
              </>
            )}
          />
          <Route path="/booklets"
            render={() => (
              <>
                <Header 
                  heading={hero[2].heading} 
                  description={hero[2].description}
                  list={hero[2].list} 
                  altText={hero[2].altText}
                  image={hero[2].image}
                  bgImage={hero[2].bgImage}
                  template={hero[2].template}
                />
                <Booklets handleChange={this.handleChange} handleChangeOther={this.handleChangeOther} handleSubmit={this.handleSubmit} />
              </>
            )}          
          />
          <Route path="/business-cards" 
            render={() => (
              <>
                <Header 
                  heading={hero[3].heading} 
                  description={hero[3].description}
                  list={hero[3].list} 
                  altText={hero[3].altText}
                  image={hero[3].image}
                  bgImage={hero[3].bgImage}
                  template={hero[3].template}
                />
                <BusinessCards handleChange={this.handleChange} handleChangeOther={this.handleChangeOther} handleSubmit={this.handleSubmit} />
              </>
            )}          
          />
          <Route path="/printing"
            render={() => (
              <>
                <Header 
                  heading={hero[4].heading} 
                  description={hero[4].description}
                  list={hero[4].list} 
                  altText={hero[4].altText}
                  image={hero[4].image}
                  bgImage={hero[4].bgImage}
                  template={hero[4].template}
                />
                <Printing handleChange={this.handleChange} handleChangeOther={this.handleChangeOther} handleSubmit={this.handleSubmit} />
              </>
            )}          
          />
          <Route path="/contact"
            render={() => (
              <>
                <Header 
                  heading={hero[1].heading} 
                  description={hero[1].description}
                  list={hero[1].list} 
                  altText={hero[1].altText}
                  image={hero[1].image}
                  bgImage={hero[1].bgImage}
                  template={hero[1].template}
                />
                <Contact home={contactInfo} />
              </>
            )}          
          />
          <Route path="/submission"
            render={() => (
              <>
                <Navbar />
                <Submission/>
              </>
            )}          
          />
          <Route
            render={() => (
              <>
                <Header 
                  heading={hero[0].heading} 
                  description={hero[0].description}
                  list={hero[0].list} 
                  altText={hero[0].altText}
                  image={hero[0].image}
                  bgImage={hero[0].bgImage}
                  template={hero[0].template}
                />
                <Home home={home} />
              </>
            )}          
          />
        </Switch>
        <Footer />
      </Router>
    );
  }
}

export default App;